import { TableCell, StatusCell } from 'ui/tableCell';
import noop from 'utils/noop';
import { DKIM } from './DKIM';
import { ESPAccount } from './ESPAccount';
import { SendingDomainsTableActionButton } from './SendingDomainsTableActionButton';
// import { TrackingDomain } from '../types';

// type ColumnProps = {
//   onDelete: () => {}, // the handler for deleting a row
//   onEdit: () => {}, // the handler for editing a row
//   onSetTrackingDomain: () => {}, // the handler for onSetTrackingDomain a row
//   onVerify: () => {}, // the handler for onVerify a row
//   defaultTrackingDomain: TrackingDomain,
//   projectHasTrackingDomains: Boolean, // whether a project has tracking domains
//   showSPFColumn: boolean, // whether or not to show the SPF Column
// };

export const configureSendingDomainsTableColumns = ({
  onDelete = noop,
  onEdit = noop,
  onSetTrackingDomain = noop,
  onVerify = noop,
  defaultTrackingDomain = {},
  projectHasTrackingDomains = false,
  showSPFColumn = false,
}) => [
  {
    name: 'Sending domain',
    align: 'flex-start',
    RowCell: ({ row }) => <TableCell>{row.domain}</TableCell>,
    sortable: true,
    value: 'domain',
  },
  {
    name: 'Tracking domain',
    align: 'flex-start',
    RowCell: ({ row }) => {
      const defaultText = defaultTrackingDomain.domain
        ? `Default (${defaultTrackingDomain.domain})`
        : '';
      return <TableCell>{row.trackingDomain || defaultText}</TableCell>;
    },
    sortable: true,
    value: 'trackingDomain',
  },
  {
    name: 'ESP account',
    align: 'flex-start',
    RowCell: ({ row }) => (
      <TableCell>{row.espAccount && <ESPAccount {...row.espAccount} />}</TableCell>
    ),
    sortable: true,
    value: 'id',
  },
  {
    name: 'DKIM record',
    align: 'flex-start',
    RowCell: ({ row }) => <TableCell>{row.dkim && <DKIM {...row.dkim} />}</TableCell>,
    searchable: false,
    sortable: false,
    value: 'dkim',
  },
  // conditionally showing this column so there's
  // more visual space if the column isn't populated.
  // spread operators make this suprisingly easy!
  ...(showSPFColumn
    ? [
        {
          name: 'SPF record',
          align: 'flex-start',
          RowCell: ({ row }) => <TableCell>{row.spf && <DKIM {...row.spf} />}</TableCell>,
          sortable: false,
          value: 'spf',
        },
      ]
    : []),
  {
    name: 'Verified',
    align: 'flex-start',
    RowCell: ({ row }) => (
      <StatusCell
        negativeLabel="Unverified"
        positiveLabel="Verified"
        showPositiveState={row.isVerified}
      />
    ),
    sortable: false,
    value: 'isVerified',
  },
  {
    name: '',
    sortable: false,
    value: 'actionCell',
    align: 'flex-start',
    RowCell: ({ row }) => (
      <TableCell>
        <SendingDomainsTableActionButton
          onDelete={onDelete}
          onEdit={onEdit}
          onSetTrackingDomain={onSetTrackingDomain}
          onVerify={onVerify}
          rowData={row}
          projectHasTrackingDomains={projectHasTrackingDomains}
        />
      </TableCell>
    ),
  },
];
